import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { useDomainDisplay } from 'src/hooks/use-domain-display.hook';
import { useUserAssets } from 'src/hooks/use-user-assets.hook';
import { hasTxAsset } from 'src/services/entitlement.service';

import './domain-badge.scss';

type Props = {
  domain?: string;
  subject?: string;
  isMiddleSchool?: boolean;
};

export const DomainBadge = ({ domain, subject, isMiddleSchool }: Props) => {
  const displayDomain = useDomainDisplay({ domain: domain ?? '', subject });
  const [domainName, setDomainName] = useState(displayDomain);
  const { data: userAssets } = useUserAssets();

  useEffect(() => {
    let processedDomain = displayDomain;
    if (hasTxAsset(userAssets)) {
      processedDomain =
        displayDomain.replace(/\bELA(?!R)/g, 'ELAR') || displayDomain;
    }
    setDomainName(processedDomain);
  }, [displayDomain, userAssets]);

  return (
    <div
      className={clsx(
        'domain-badge',
        `domain-badge--${domainName.toLowerCase().split(' ').join('-')}`,
        {
          'domain-badge--middle-school': isMiddleSchool,
        },
      )}
    >
      {domainName}
    </div>
  );
};
